import { type Finplan } from '@fin/shared';


import { useRef } from 'react';
import { Icon } from '../../components/ui.tsx';

import { useWallets } from '../../lib/data.ts';
import { plural, rub } from '../../lib/format.ts';
import { useQuery } from '../../lib/query.ts';



export function CapitalHero({ year, onYear }: { year: number | null; onYear: (y: number) => void }) {
  const plan = useQuery<Finplan>('/finplan');
  const wallets = useWallets();
  const now = new Date().getFullYear();
  const swipe = useRef<number | null>(null);
  const invested = (wallets.data ?? []).filter((w) => w.type === 'investment' && !w.archived).reduce((s, w) => s + (w.balanceBase ?? 0), 0);
  const thisYear = (plan.data?.contributions ?? []).filter((c) => c.year === now).reduce((s, c) => s + c.amount, 0);
  const rows = plan.data?.rows ?? [];
  if (!plan.data || !wallets.data) return <div className="skeleton sk-hero" aria-busy="true" aria-label="Загружаю капитал" />;
  const idx = Math.max(0, year === null ? rows.length - 1 : rows.findIndex((r) => r.year === year));
  const row = rows[idx];
  const step = (d: -1 | 1) => { const r = rows[idx + d]; if (r) onYear(r.year); };
  return (
    <section className="hero capital" aria-label="Капитал">
      <div className="hero-top">
        <span className="hero-label">Вложено сейчас</span>
        <span className="hero-big money">{rub(invested)}</span>
        <span className="hero-sub">в {now} году внесено <span className="money">{rub(thisYear)}</span></span>
      </div>
      {row ? (
        <div className="capital-year"
          onPointerDown={(e) => { swipe.current = e.clientX; }}
          onPointerUp={(e) => { if (swipe.current === null) return; const dx = e.clientX - swipe.current; swipe.current = null; if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1); }}
          onPointerCancel={() => { swipe.current = null; }}>
          <div className="capital-year-nav">
            <button type="button" className="icon-btn icon-btn-framed" aria-label="Предыдущий год" disabled={idx === 0} onClick={() => step(-1)}><Icon name="left" /></button>
            <span className="capital-year-title" aria-live="polite"><strong>{row.year}</strong> · {row.age} {plural(row.age, 'год', 'года', 'лет')}{row.isActual ? (row.forecastMonths ? ' · факт и прогноз' : ' · факт') : ''}</span>
            <button type="button" className="icon-btn icon-btn-framed" aria-label="Следующий год" disabled={idx === rows.length - 1} onClick={() => step(1)}><Icon name="right" /></button>
          </div>
          <dl className="capital-goal" key={row.year}>
            <div><dt>Капитал</dt><dd className="money">{rub(row.totalCapital)}</dd></div>
            <div><dt>В сегодняшних деньгах</dt><dd className="money">{rub(row.realCapital)}</dd></div>
            <div><dt>Пассивный доход в месяц</dt><dd className="money">{rub(row.passiveMonth)}</dd></div>
          </dl>
        </div>
      ) : null}
    </section>
  );
}
